import { get, toLower } from "lodash"

export const ASSETS_SUBQUERY = `
equities{
  id{
    ticker
    mic
    modelProviderId
    figi
    bloombergTicker
    internalId
  }
  economicExposure
}
swaps {
  id,
  economicExposure
}
currencies {
  id,
  economicExposure
}
fixedIncome {
  id {
    isin
  }
  economicExposure
}
commodities {
  id
  economicExposure
}
indexes {
  id
  economicExposure
}
otherAssets {
  id
  economicExposure
}`

export function getRefInstrumentResource(topic) {
  const { securityId, portfolioId, type } = get(topic, "referenceInstrument", topic) || {}
  return {
    type: toLower(type),
    id: portfolioId || securityId,
  }
}
